import { AuctionResource } from 'app/_resources/auction.resource';
import { ConversionService } from 'app/_directives/conversionService';
import { UtilService } from 'app/_services/util.service';
import * as angular from 'angular';
import { Growl } from 'angular/custom/services/growl.service';
import { Debounce } from '../_services/debounce.factory';
import { ComfortBidDtoWithConfig } from '../custom';

class ComfortBidEditFormComponentCtrl implements ng.IController {
    comfortBid: ComfortBidDtoWithConfig;
    networkPoint: NetworkPointDto;

    loadingTsoConfig: boolean = false;
    nonUndiscountedTariffsSupported: boolean;
    minRuntimeStart: Date;
    form: angular.IFormController;

    private debouncedMaxQuantityValidate;

    constructor(
        private auctionResource: AuctionResource,
        private conversionService: ConversionService,
        private growl: Growl,
        private utilService: UtilService,
        private debounce: Debounce
    ) {}

    $onInit(): void {
        this.minRuntimeStart = new Date(
            this.utilService.getCurrentGasDayStart()
        );
        if (
            new Date(this.comfortBid.orderRuntime.start as string) <
            this.minRuntimeStart
        ) {
            this.comfortBid.orderRuntime.start = this.minRuntimeStart;
        }

        this.comfortBid._showUpgradeSettings = !!(
            this.comfortBid.upgrade0 || this.comfortBid.upgrade1
        );
        this.comfortBid._showConversionSettings = !!(
            (this.comfortBid.conversions &&
                this.comfortBid.conversions[0] &&
                this.comfortBid.conversions[0].conversion0) ||
            (this.comfortBid.conversions &&
                this.comfortBid.conversions[0] &&
                this.comfortBid.conversions[0].conversion1)
        );
        this.nonUndiscountedTariffsSupported =
            this.networkPoint.undiscountedTariffs &&
            this.networkPoint.connectionPointType === 'RESERVOIR';

        this.debouncedMaxQuantityValidate = this.debounce(
            () => this.form != null && this.form['maxQuantity'].$validate(),
            500
        );
    }

    $doCheck(): void {
        if (
            this.form &&
            this.form.$$parentForm &&
            this.form.$$parentForm.$submitted
        ) {
            this.form.$setSubmitted();
        }
    }

    $postLink(): void {
        this.comfortBid.id != null && this.form && this.form.$setSubmitted();
    }

    public getConfigIfAllCapacityInformationIsProvided(): void {
        const capacityCategoriesProvided: boolean = this.networkPoint.bundled
            ? !!(
                  this.comfortBid.capacityCategory0 &&
                  this.comfortBid.capacityCategory1
              )
            : !!this.comfortBid.capacityCategory0;

        if (!capacityCategoriesProvided || !this.comfortBid.orderRuntime) {
            return;
        }

        this.loadingTsoConfig = true;

        this.auctionResource
            .comfortBidConfig(
                {
                    networkPointId: this.networkPoint.id,
                    capacityCategory0: this.comfortBid.capacityCategory0,
                    capacityCategory1: this.comfortBid.capacityCategory1,
                    runtimeStart: this.comfortBid.orderRuntime.start,
                    runtimeEnd: this.comfortBid.orderRuntime.end
                },
                (res: ComfortBidConfigDto) => {
                    this.comfortBid._config = res;
                    this.comfortBid._isUpgradePossible =
                        this.conversionService.isUpgradePossible(
                            res,
                            this.comfortBid.capacityCategory0,
                            this.comfortBid.capacityCategory1
                        );
                    this.comfortBid._isConversionPossible =
                        this.conversionService.isConversionPossible(
                            res,
                            this.networkPoint.bundled
                        );
                },
                (err: ng.IHttpPromiseCallbackArg<RestError>) => {
                    this.comfortBid._config = null;

                    let message: string =
                        err.data && err.data.message
                            ? err.data.message
                            : `Something went wrong when loading ${
                                  this.networkPoint.bundled ? 'TSOs’' : 'TSO’s'
                              } comfort bid configuration${
                                  this.networkPoint.bundled ? 's' : ''
                              }.`;
                    message +=
                        ' Unfortunately you can’t proceed from here. Please, check back later.';

                    this.growl.show(message, 'danger', {
                        errorCode: err.data.errorCode
                    });
                }
            )
            .$promise.finally(() => (this.loadingTsoConfig = false));
    }

    public findMaxConversionAmount(): number | null {
        const maxQuantityOfConversions =
            this.conversionService.findMaxQuantityOfConversions(
                this.comfortBid.conversions &&
                    this.comfortBid.conversions[0] &&
                    this.comfortBid.conversions[0].conversion0 != null &&
                    this.comfortBid._config.limitBidMandatoryForConversion0
                    ? this.comfortBid.conversions[0].conversion0.intervals
                    : null,
                this.comfortBid.conversions &&
                    this.comfortBid.conversions[0] &&
                    this.comfortBid.conversions[0].conversion1 != null &&
                    this.comfortBid._config.limitBidMandatoryForConversion1
                    ? this.comfortBid.conversions[0].conversion1.intervals
                    : null
            );
        return maxQuantityOfConversions != null
            ? maxQuantityOfConversions.toNumber()
            : null;
    }

    public onConversionAmountChange() {
        this.debouncedMaxQuantityValidate().then(angular.noop);
    }
}

angular.module('app').component('pkpComfortBidEditForm', {
    controller: ComfortBidEditFormComponentCtrl,
    template: require('app/comfort-bid/comfort-bid-edit-form.component.html'),
    bindings: {
        comfortBid: '=',
        networkPoint: '='
    }
});
